module.exports = __webpack_public_path__ + "static/media/idlepage-companies.65676ff4.svg";